module.exports = __webpack_public_path__ + "static/media/comment2_3.346f9d39.png";